import React from "react";
import PropTypes from "prop-types";

export default function AtasDeviceIcon({ fill, size }) {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 8.467 8.467"
  >
    <path
      d="M2.948.33c-.66 0-1.193.442-1.193.99v2.14c0 .548.532.99 1.193.99h.027v2.67c0 .59.573 1.064 1.284 1.064S5.544 7.71 5.544 7.12V4.45h.027c.661 0 1.193-.441 1.193-.99V1.32c0-.548-.532-.99-1.193-.99z"
      style={{
        fill: "none",
        stroke: "#3b3b3bff",
        strokeWidth: 0.52916667,
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        strokeOpacity: 1,
        paintOrder: "markers fill stroke",
      }}
    />
    <ellipse
      cx={4.26}
      cy={5.791}
      rx={0.549}
      ry={0.491}
      style={{
        fill: [fill],
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 0.861888,
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        paintOrder: "markers fill stroke",
      }}
    />
    <rect
      width={3.045}
      height={0.693}
      x={2.737}
      y={2.043}
      ry={0.028}
      style={{
        fill: {fill},
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 0.660617,
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeDasharray: "none",
        paintOrder: "markers fill stroke",
      }}
    />
  </svg>
  );
}

AtasDeviceIcon.defaultProps = {
  size: "40",
  fill: "#4b4b4b",
};

AtasDeviceIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string,
};
